import React from 'react';
import { Reveal } from '../components/Reveal';
import { BookingCta } from '../components/BookingCta';
import { gallery } from '../data/content';
export function Work() {
  return <>
      <section className="mx-auto max-w-shell px-5 pb-8 pt-24 sm:px-6 sm:pt-32 lg:px-10 lg:pt-44" data-id="element-1143" data-mp="2z87wansw1mc1">
        <Reveal className="max-w-3xl" data-id="element-1144" data-mp="346rk6tr1l871">
          <span className="flex items-center gap-3" data-id="element-1145" data-mp="347krbvtwxzpp">
            <span className="hairline h-px w-10" aria-hidden="true" data-id="element-1146" data-mp="3rwvl2tcuituc" />
            <span className="text-[11px] uppercase tracking-[0.28em] text-ember" data-id="element-1147" data-mp="3ryq4224k4bvs">Ons werk</span>
          </span>
          <h1 className="mt-6 font-display text-4xl font-extrabold leading-[1.03] tracking-tightest text-chalk sm:text-5xl" data-id="element-1148" data-mp="3w01qjys4wgzr">
            Elke auto gaat de deur uit zoals we hem zelf zouden willen.
          </h1>
          <p className="mt-7 max-w-xl text-base leading-relaxed text-dim" data-id="element-1149" data-mp="eqdd2z6u4le5">
            Een blik op recent werk uit de werkplaats — wasbeurten, interieurs, lakcorrecties en coatings.
          </p>
        </Reveal>
      </section>

      <section className="mx-auto max-w-shell px-6 py-14 lg:px-10 lg:py-20" data-id="element-1150" data-mp="3ian2k05qz2n8">
        <div className="grid auto-rows-[200px] grid-cols-2 gap-4 lg:auto-rows-[250px] lg:grid-cols-4" data-id="element-1151" data-mp="3e8jpj73fjpzu">
          {gallery.map((shot, i) => <Reveal key={shot.src} delay={i % 4 * 0.05} className={`group overflow-hidden rounded-2xl border border-edge ${shot.span === 'tall' ? 'row-span-2' : ''} ${shot.span === 'wide' ? 'col-span-2' : ''}`} data-id="element-1152" data-mp="3s0zitg6j49nk" data-mpi={i}>
              <img src={shot.src} alt={shot.alt} className="h-full w-full object-cover transition-transform duration-300 ease-smooth group-hover:scale-[1.05]" data-id="element-1153" data-mp="sltb4g0lntm" />
            </Reveal>)}
        </div>
      </section>

      <BookingCta data-id="element-1154" data-mp="2gl15h04bj1gj" />
    </>;
}